Array.prototype.remove = function(val) {
  const index = this.indexOf(val)
  if (index > -1) {
    this.splice(index, 1)
  }
}

const collUtil = {
  methods: {
    listToMap: function(list, propName) {
      const map = {}
      if (list) {
        for (const obj of list) {
          map[obj[propName]] = obj
        }
      }
      return map
    },
    listToListMap: function(list, propName) {
      const map = {}
      if (list) {
        for (const obj of list) {
          const prop = obj[propName]
          let list = map[prop]
          if (!list) {
            list = []
            map[prop] = list
          }
          list.push(obj)
        }
      }
      return map
    },
    /**
     * 分组，返回map<key, list>
     */
    listToMapGroupBy: function(list, propName) {
      const map = {}
      if (list) {
        for (const obj of list) {
          const prop = obj[propName]
          let list = map[prop]
          if (!list) {
            list = []
            map[prop] = list
          }
          list.push(obj)
        }
      }
      return map
    },
    contains: function(list, o) {
      return list.indexOf(o) > -1
    },
    // 多维数组排列组合
    doExchange(arr) {
      const len = arr.length
      // 当数组大于等于2个的时候
      if (len >= 2) {
        // 第一个数组的长度
        const len1 = arr[0].length
        // 第二个数组的长度
        const len2 = arr[1].length
        // 2个数组产生的组合数
        const lenBoth = len1 * len2
        //  申明一个新数组
        const items = new Array(lenBoth)
        // 申明新数组的索引
        let index = 0
        for (let i = 0; i < len1; i++) {
          for (let j = 0; j < len2; j++) {
            if (arr[0][i] instanceof Array) {
              items[index] = arr[0][i].concat(arr[1][j])
            } else {
              items[index] = [arr[0][i]].concat(arr[1][j])
            }
            index++
          }
        }
        const newArr = new Array(len - 1)
        for (let i = 2; i < arr.length; i++) {
          newArr[i - 1] = arr[i]
        }
        newArr[0] = items
        return doExchange(newArr)
      } else {
        return arr[0]
      }
    }
  }
}
/**
 * Array/List/Set/Map 常用集合工具类
 */
export default collUtil

export const listToMap = collUtil.methods.listToMap
export const listToListMap = collUtil.methods.listToListMap
export const listToMapGroupBy = collUtil.methods.listToMapGroupBy
export const contains = collUtil.methods.contains
export const doExchange = collUtil.methods.doExchange
